import React, { FC } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';
import { ReactComponent as DivideIcon } from 'src/icons/divide.svg';
import { ReactComponent as LeftBraceIcon } from 'src/icons/leftBrace.svg';
import { ReactComponent as RightBraceIcon } from 'src/icons/rightBrace.svg';

interface OperatorIconProps {
  operator: string;
}

export enum Operator {
  MINUS = '-',
  PLUS = '+',
  DIVIDE = '/',
  MULTIPLY = 'x',
  LEFT_BRACE = '(',
  RIGHT_BRACE = ')',
}

export const OperatorIcon: FC<OperatorIconProps> = ({ operator }) => {
  switch (operator) {
    case Operator.PLUS:
      return <AddIcon />;
    case Operator.MINUS:
      return <RemoveIcon />;
    case Operator.DIVIDE:
      return <DivideIcon />;
    case Operator.MULTIPLY:
      return <CloseIcon />;
    case Operator.LEFT_BRACE:
      return <LeftBraceIcon />;
    case Operator.RIGHT_BRACE:
      return <RightBraceIcon />;
    default:
      return null;
  }
};
